/**
 * @generated SignedSource<<bf95bb1e660756ecbb2c81a02753d3c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "HomePage_navigationItems",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimpleMenuMainNavigation_navigationItems"
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "b193c5d8b1feb96f1bf882f0e4701ade";

module.exports = node;
